export default __webpack_public_path__ + "static/ProValue_4@768-e211272d4f1f71a05aee5643d39e764d.webp";